
const Tray = ({ children }) => {
    return (
        <div className='tray-container'>
            {children}
        </div>
    )
}

export default Tray
